export class TimeZoneConfig {
    localTimeZoneStandardName(): string {
        return 'Eastern Standard Time';
    }
}
